import { Liquid } from '@antv/g2plot';
import { forwardRef } from 'react';
import BaseChart from '../../components/base';
import { jsx as _jsx } from "react/jsx-runtime";
const LiquidChart = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(BaseChart, {
    chart: Liquid,
    ref: ref,
    ...props
  });
});
export default LiquidChart;